import React, { Component } from "react"
import Svg from "../../shared/_svgs/svg"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"

export class ItineraryUspContainer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      block: props.block,
    }
  }

  render() {
    return (
      <div className="departure-info__essentials__detailitems__detailitem__infobox__list__view">
        <ul className="grid">
          {this.props.block.uspBlocks && this.props.block.uspBlocks.length > 0
            ? this.props.block.uspBlocks.map((usp, i) => {
                const uspSvg = SelectionFactoryHelper.getFromSelectionFactory(usp.svgIcon)
                const icon = usp.iconUpload ? <img src={usp.iconUpload} /> : uspSvg ? <Svg iconName={uspSvg} /> : ""
                return (
                  <li key={i} className="grid-item col--12 col-sm--4">
                    {icon}
                    <div className="info-text rich-text" dangerouslySetInnerHTML={{ __html: usp.uspText }}></div>
                  </li>
                )
              })
            : ""}
        </ul>
      </div>
    )
  }
}
